var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10491 6.28794C8.33763 7.48317 7.71947 8.9545 7.35592 10.5036L8.25992 11.3777L9.87058 9.94212L11.2142 9.97041L12.6428 11.3534L14.0739 9.9699L15.4465 9.9694L16.8812 11.3543L17.6724 10.5895C17.3372 8.9879 16.7708 7.47227 16.0552 6.25289C14.9874 4.43314 13.7664 3.54762 12.699 3.54762C11.6064 3.54762 10.275 4.46525 9.10491 6.28794ZM5.02412 12.6357C5.05276 12.1615 5.10494 11.6867 5.17871 11.2148L3.60181 9.69009L1.82227 9.68806L1.82449 7.64044L4.00097 7.64291L4.68648 7.9224L5.71303 8.91501C6.13639 7.54699 6.728 6.26242 7.43358 5.16331C8.72243 3.15561 10.5775 1.5 12.699 1.5C14.8455 1.5 16.5897 3.18772 17.7696 5.19837C18.9819 7.26416 19.789 9.96669 19.9711 12.6274C20.1584 15.3621 19.4514 17.4923 18.0173 18.9308L17.9933 18.9547C17.8338 18.922 17.6689 18.9049 17.5 18.9049C16.417 18.9049 15.4948 19.61 15.1475 20.5962C14.3196 20.8397 13.4341 20.9524 12.5283 20.9524C11.6005 20.9524 10.6936 20.8341 9.84724 20.5787C9.49523 19.6016 8.57758 18.9049 7.50098 18.9049C7.34399 18.9049 7.19039 18.9197 7.04142 18.948L7.02717 18.9339C5.5842 17.4989 4.85886 15.3717 5.02412 12.6357Z",
    fill: "#3360AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.999 21.4644C18.999 22.3126 18.3275 23.0001 17.499 23.0001C16.6706 23.0001 15.999 22.3126 15.999 21.4644C15.999 20.6163 16.6706 19.9287 17.499 19.9287C18.3275 19.9287 18.999 20.6163 18.999 21.4644Z",
    fill: "#EA1763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.4644C9 22.3126 8.32843 23.0001 7.5 23.0001C6.67157 23.0001 6 22.3126 6 21.4644C6 20.6163 6.67157 19.9287 7.5 19.9287C8.32843 19.9287 9 20.6163 9 21.4644Z",
    fill: "#208C72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggFull);
export default __webpack_public_path__ + "static/media/egg-full.feaa5ddb52a367853361fbc69b570025.svg";
export { ForwardRef as ReactComponent };